import keycloakAxios from '@/services/axios';
import {emitEventChangeEvent} from './change-observable';

export const getEventById = async (eventId: string, pastEvents?: boolean) => {
  const response = await keycloakAxios.get(
    `event/get/${eventId}/${pastEvents}`
  );

  if (response.status >= 300) {
    throw new Error(
      `Error getting event: Invalid status code: ${response.status}`
    );
  }

  const updatedResponseData = {
    ...response.data,
    price: response.data.price > 0 ? response.data.price / 100 : 0
  };

  emitEventChangeEvent({
    type: 'change',
    data: updatedResponseData
  });

  return updatedResponseData;
};
